exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".price-notes {\n  font-size: 12px;\n  color: #777;\n}\n\n.byline {\n  font-size: 12;\n  color: #777;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/snowriders/app/src/app/post.component.css
// module id = ../../../../../src/app/post.component.css
// module chunks = main